"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalSettingsDialog = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const form_checkbox_1 = require("../../composite/form/fields/form-checkbox");
const form_editor_1 = require("../../composite/form/fields/form-editor");
const form_instant_field_1 = require("../../composite/form/fields/form-instant-field");
const form_local_date_field_1 = require("../../composite/form/fields/form-local-date-field");
const form_local_date_time_field_1 = require("../../composite/form/fields/form-local-date-time-field");
const form_select_1 = require("../../composite/form/fields/form-select");
const form_text_area_1 = require("../../composite/form/fields/form-text-area");
const form_text_field_1 = require("../../composite/form/fields/form-text-field");
const form_text_field_multiple_1 = require("../../composite/form/fields/form-text-field-multiple");
const form_time_field_1 = require("../../composite/form/fields/form-time-field");
const selector_1 = require("../../composite/form/selectors/selector");
const list_source_hook_1 = require("../../utils/list-source-hook");
const key_value_inline_table_1 = require("./field-components/key-value-inline-table");
const internal_settings_context_1 = require("./internal-settings-context");
const internal_settings_types_1 = require("./internal-settings-types");
function InternalSettingsDialog() {
    var _a, _b;
    const { config } = (0, react_1.useContext)(internal_settings_context_1.InternalSettingsConfigContext);
    const setting = (0, selector_1.useFormSelector)((data) => data);
    const DefaultValueComponent = useDeriveValueDefaultComponent(setting);
    const ValueComponent = (_b = (_a = config === null || config === void 0 ? void 0 : config.find((settingConfig) => setting.code === settingConfig.code)) === null || _a === void 0 ? void 0 : _a.FieldComponent) !== null && _b !== void 0 ? _b : DefaultValueComponent;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const Value = (0, react_1.useMemo)(() => ValueComponent, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(form_text_area_1.FormTextArea, { name: "name", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTIINGS__DIALOG__FIELD_LABEL__NAME", defaultMessage: "N\u00E1zev" }), disabled: true }),
        react_1.default.createElement(form_text_area_1.FormTextArea, { name: "description", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTIINGS__DIALOG__FIELD_LABEL__DESCRIPTION", defaultMessage: "Popis" }), disabled: true }),
        react_1.default.createElement(Value, { name: "value", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTIINGS__DIALOG__FIELD_LABEL__VALUE", defaultMessage: "Hodnota" }), disabled: !setting.canEdit }),
        react_1.default.createElement(form_text_area_1.FormTextArea, { name: "comment", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTIINGS__DIALOG__FIELD_LABEL__COMMENT", defaultMessage: "Koment\u00E1\u0159" }), disabled: !setting.canEdit }),
        react_1.default.createElement(form_instant_field_1.FormInstantField, { name: "updated", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTIINGS__DIALOG__FIELD_LABEL__UPDATED", defaultMessage: "Posledn\u00ED \u00FAprava" }), disabled: true }),
        react_1.default.createElement(form_text_field_1.FormTextField, { name: "updatedBy.name", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__INTERNAL_SETTIINGS__DIALOG__FIELD_LABEL__UPDATED_BY", defaultMessage: "Autor \u00FApravy" }), disabled: true })));
}
exports.InternalSettingsDialog = InternalSettingsDialog;
const useDeriveValueDefaultComponent = ({ collection = false, options = [], inputType, }) => {
    var _a;
    const selectSource = (0, list_source_hook_1.useStaticListSource)((_a = options.map((option) => typeof option === 'string' ? { id: option } : option)) !== null && _a !== void 0 ? _a : []);
    switch (inputType.name) {
        case internal_settings_types_1.SimpleEasSettingInputType.SINGLE_LINE_STRING:
            return collection ? form_text_field_multiple_1.FormTextFieldMultiple : form_text_field_1.FormTextField;
        case internal_settings_types_1.SimpleEasSettingInputType.MULTI_LINE_STRING:
            return form_text_area_1.FormTextArea;
        case internal_settings_types_1.SimpleEasSettingInputType.CHECKBOX:
            return form_checkbox_1.FormCheckbox;
        case internal_settings_types_1.SimpleEasSettingInputType.DATE:
            return form_local_date_field_1.FormLocalDateField;
        case internal_settings_types_1.SimpleEasSettingInputType.DATE_TIME:
            return form_local_date_time_field_1.FormLocalDateTimeField;
        case internal_settings_types_1.SimpleEasSettingInputType.INSTANT:
            return form_instant_field_1.FormInstantField;
        case internal_settings_types_1.SimpleEasSettingInputType.TIME:
            return form_time_field_1.FormTimeField;
        case internal_settings_types_1.SimpleEasSettingInputType.JSON:
            return function Component(props) {
                return react_1.default.createElement(form_editor_1.FormEditor, { ...props, language: "json" });
            };
        case internal_settings_types_1.SimpleEasSettingInputType.SELECT:
            return function Component(props) {
                return (react_1.default.createElement(form_select_1.FormSelect, { ...props, valueIsId: true, source: selectSource, labelMapper: (option) => { var _a; return (_a = option === null || option === void 0 ? void 0 : option.name) !== null && _a !== void 0 ? _a : option.id; } }));
            };
        case internal_settings_types_1.SimpleEasSettingInputType.INTEGER:
            return function Component(props) {
                return collection ? (react_1.default.createElement(form_text_field_multiple_1.FormTextFieldMultiple, { ...props, type: "number" })) : (react_1.default.createElement(form_text_field_1.FormTextField, { ...props, type: "number" }));
            };
        case internal_settings_types_1.SimpleEasSettingInputType.KEY_VALUE_MAP:
            return key_value_inline_table_1.KeyValueInlineTable;
        default:
            return form_text_field_1.FormTextField;
    }
};
//# sourceMappingURL=internal-settings-dialog.js.map